<template>
  <div class="grid-string grid-string-total">
    <Cell class="cell-left">
      <div :class="isSubtotal || isTotal ? 'flex-line' : ''">
        <div>
          <span>{{ $t(label) }}</span>
        </div>
        <div
          v-if="isSubtotal || isTotal"
          :class="{ 'add-purple': isTotal }"
          class="add"
          @click="newRow"
        >
          <div class="icon-svg icon-svg-mr4 w-embed">
            <PlusIcon />
          </div>
          <div>{{ isSubtotal ? $t('add parameters') : $t('add taxes') }}</div>
        </div>
      </div>
    </Cell>

    <CurrencyEntry :currency="currency" :text="one" is-span />
    <CurrencyEntry :currency="currency" :text="two" is-span />
    <CurrencyEntry :currency="currency" :text="three" is-span />
    <CurrencyEntry
      :currency="currency"
      :text="total"
      :is-white="isTotal"
      is-bold
      is-span
      class="total-cell"
    />
  </div>
</template>

<script>
  import CurrencyEntry from '@/components/common/CurrencyEntry';
  import Cell from '@/components/common/Cell';
  import PlusIcon from '@/assets/icons/plus.svg';

  export default {
    name: 'SummaryTotal',
    components: { PlusIcon, Cell, CurrencyEntry },
    props: {
      label: String,
      isSubtotal: {
        type: Boolean,
        default: false,
      },
      isTotal: {
        type: Boolean,
        default: false,
      },
      currency: {
        type: String,
        required: true,
      },
      one: [Number, String],
      two: [Number, String],
      three: [Number, String],
      four: [Number, String],
      total: [Number, String],
    },
    methods: {
      newRow() {
        if (this.isSubtotal) this.$emit('subtotal');
        else if (this.total) this.$emit('total');
      },
    },
  };
</script>
